<script setup lang="ts">
import { ref } from 'vue'
import PDataTable from 'primevue/datatable'
import PColumn from 'primevue/column'

interface AsmeB407Accuracy {
  grade: string
  accuracy: string
  test_points: number
}

const columns = ref([
  { field: 'grade', header: 'Grade' },
  { field: 'accuracy', header: 'Accuracy' },
  { field: 'test_points', header: 'Rec. # of Test Points' }
])

const asmeB407 = ref<AsmeB407Accuracy[]>([
  {
    grade: '5A',
    accuracy: '± 0.05% of span',
    test_points: 15
  },
  {
    grade: '4A',
    accuracy: '± 0.1% of span',
    test_points: 10
  },
  {
    grade: '3A',
    accuracy: '± 0.25% of span',
    test_points: 5
  },
  {
    grade: '2A',
    accuracy: '± 0.5% of span',
    test_points: 5
  },
  {
    grade: 'A',
    accuracy: '± 1.0% of span',
    test_points: 5
  },
  {
    grade: 'B',
    accuracy: '± 2.0% of span',
    test_points: 3
  },
  {
    grade: '5AR',
    accuracy: '± 0.05% of reading',
    test_points: 15
  },
  {
    grade: '4AR',
    accuracy: '± 0.1% of reading',
    test_points: 10
  },
  {
    grade: '3AR',
    accuracy: '± 0.25% of reading',
    test_points: 5
  },
  {
    grade: '2AR',
    accuracy: '± 0.5% of reading',
    test_points: 5
  },
  {
    grade: 'AR',
    accuracy: '± 1.0% of reading',
    test_points: 5
  },
  {
    grade: 'BR',
    accuracy: '± 2.0% of reading',
    test_points: 3
  }
])
</script>

<template>
  <div class="mb-4">
    <h3 class="m-0 text-3xl">
      ASME B40.7
    </h3>
    <span class="block">
      Accuracy for Pressure Indicating Digital Gauges
    </span>
  </div>
  <p-data-table
    :value="asmeB407"
    class="border-1 border-200"
  >
    <p-column
      v-for="col in columns"
      :key="col.field"
      :field="col.field"
      :header="col.header"
    />
    <template #footer>
      <div class="text-sm font-italic">
        * The test points shall be distributed over the dial range and shall include points within 10% of the ends of the
        dial range.
      </div>
    </template>
  </p-data-table>
</template>

<style scoped>
.p-column-header-content {
  background-color: blue !important;
}
</style>
